import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import MapSearch from "@/pages/MapSearch";

export const Route = createFileRoute("/map-search")({ head: () => routeMeta('Map Property Search | MNRE', 'Explore Mumbai properties by location on an interactive map.', '/map-search'), component: MapSearch });
